// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2gciG","title":"Info_title__3TeW2","links":"Info_links__FFzqa","link":"Info_link__9PG-b","logo":"Info_logo__1Hr0u"};